const SDK_VERSION = "10.61.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
